import React from 'react'

const Error = () => {
    return (
    <>
    <section className='error'>
        <h1>Error: Esta página no existe!</h1>

    </section>
    </>
    )
}

export default Error
